<div class="phx-radio-select-group">
  <label
    *ngFor="let option of phxOptions"
    class="phx-radio-select-wrapper"
    [class.phx-checked]="phxValue === option.value"
  >
    <span class="phx-radio-select-input-wrapper">
      <input
        type="radio"
        class="phx-radio-select-input"
        [value]="option.value"
        [ngModel]="phxValue"
        [attr.tabindex]="disabled ? -1 : null"
        (ngModelChange)="handleValueChange($event)"
        (keydown)="handleKeyDown($event)"
      />
      <span class="phx-radio-select-outline"></span>
    </span>
    <span
      class="phx-radio-select-label"
      [ngClass]="{
        'phx-web-type-body-medium': phxSize === 'medium',
        'phx-web-type-body-extra-small': phxSize === 'extra-small'
      }"
    >
      {{option.label}}
    </span>
  </label>
</div>
